import React from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Container, DashboardSubNavs } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { useViewport } from '../../utils'
import {
  ContentEmail,
  ContentPassword,
} from './components'

const Content = () => {
  const account = useSelector(state => state.account.data)

  return (
    <React.Fragment>
      <Route path="/dashboard/settings/password" exact>
        <ContentPassword data={account}/>
      </Route>
      <Route path="/dashboard/settings" exact>
        <ContentEmail data={account}/>
      </Route>
    </React.Fragment>
  )
}

const DashboardSettings = () => {
  const { isDesktop } = useViewport()
  const { translate } = useInternationalization()

  const subroutes = [
    {
      label: translate('GENERAL', 'account'),
      route: '/dashboard/settings',
      exact: true
    },
    {
      label: translate('AUTH', 'password'),
      route: '/dashboard/settings/password'
    }
  ]

  return isDesktop ? (
    <div>
      <h1 className="text-4xl font-bold font-primary mb-10">
        {translate('DASHBOARD', 'account_settings')}
      </h1>
      <DashboardSubNavs links={subroutes}/>
      <Content />
    </div>
  ) : (
    <React.Fragment>
      <DashboardSubNavs links={subroutes} />
      <Container>
        <Content />
      </Container>
    </React.Fragment>
  )
}

export { DashboardSettings }
